import {
  fetchingUserData,
  fetchingOrders,
  fetchingNotes,
  fetchingPhones,
  addNote,
  deleteNote,
} from './actions';
export const initialState = {
  fetchingUserData,
  fetchingOrders,
  fetchingNotes,
  fetchingPhones,
  addNote,
  deleteNote,
  freight: null,
  notes: null,
  orders: null,
  phones: null,
};

export const reducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'FREIGHT':
      return { ...state, freight: payload };
    case 'LOAD':
      return {
        ...state,
        [payload.name]: payload.value,
      };
    case 'NOTES':
      return { ...state, notes: payload };
    default:
      return state;
  }
};
